import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { post, API_URL } from 'lib/network/api';

export function useCreateInvoiceMutation() {
  return useMutation({
    mutationFn: async (payload) => {
      const res = await post(`${API_URL}/api/invoice`, payload);
      return res;
    },
    onSuccess: (res) => {
      toast.success('Invoice created!');
      if (res?.payment_url) {
        window.open(res.payment_url, '_self');
      }
    },
  });
}
